import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, ComputedRef } from 'vue'
import { Collection } from '@eencloud/eewc-components/src/components/text-inputs/searchBar/types'
import { ApiCameraWithIncludes, FloorResponse } from '@eencloud/eewc-components/src/service/api-types'
import router from '@/service/router'
import {useFloorsStore, useLocationsStore } from '@/stores'
import { t } from '@/plugins/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchComponent',
  setup(__props) {

const floors = useFloorsStore()
const locations = useLocationsStore()

const searchFloorplan = ref<string>('');

const searchCollection: ComputedRef<Collection[]> = computed(() => {
  return [
    {
      items: floors.floors || [],
      typeName: 'Floorplan',
      typeIcon: '$icon_floorplan',
      callback: async function(value) {
        await floors.setCurrentFloor(value as FloorResponse)
      }
    },
    {
      items: floors.currentFloorCameras || [],
      typeName: 'Camera',
      typeIcon: '$icon_camera',
      callback: function(value) {
        redirectToLiveView(value as ApiCameraWithIncludes)
      }
    }
  ]
})

const redirectToLiveView = function (camera: ApiCameraWithIncludes) {
  const locationId = locations.currentLocation?.id
  const floorId = floors.currentFloor?.id
  const routeCameraId = router.currentRoute.params.cameraId
  if(routeCameraId === camera.id) return
  router.push({ 'path': `/location/${locationId}/floor_plan/${floorId}/video/${camera.id}` })
}


return { __sfc: true,floors, locations, searchFloorplan, searchCollection, redirectToLiveView, t }
}

})